import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../../../constants/Languages.js';

//img
import typeBook from '../../../../assets/icons/type-book.svg';
import typeSpectacle from '../../../../assets/icons/type-spectacle.svg';
import typeMovie from '../../../../assets/icons/type-movie.svg';
import typeRadio from '../../../../assets/icons/type-radio.svg';
import typeTV from '../../../../assets/icons/type-tv.svg';
import typeJournalItem from '../../../../assets/icons/type-journal-item.svg';
import typeBookContent from '../../../../assets/icons/book-content.svg';

import { getTextMetadataDataTransformed } from '../../../../scripts/TextMetadata.js';

const RecordSectionDesc = ({clang, text, label, type}) => {
    const getImg = () => {
        let imgType;

        switch (type) {
          case 'spectacle':
              imgType = typeSpectacle;
              break;
          case 'movie':
              imgType = typeMovie;
              break;
          case 'television':
              imgType = typeTV;
              break;
          case 'radio':
              imgType = typeRadio;
              break;
          case 'journal-item':
              imgType = typeJournalItem;
              break;
          case 'book':
              imgType = typeBook;
              break;
          case 'content':
              imgType = typeBookContent;
              break;
          default:
              break;
        }

        return <img src={imgType} alt={lang[clang].alt.record_type} className="record__section__desc-img"/>;
    };

    return (
        <div className="record__section--desc">
            <h4 className="record__section-label--desc" dangerouslySetInnerHTML={{__html: lang[clang].item[label]}}></h4>
            <div className="record__section__desc">
                <div className="record__section__desc-img-container">{getImg()}</div>
                <span dangerouslySetInnerHTML={{__html: getTextMetadataDataTransformed(text)}}></span>
            </div>
        </div>
    );
};

RecordSectionDesc.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(RecordSectionDesc);



// WEBPACK FOOTER //
// ./src/components/items/records/common/RecordSectionDesc.js